import { createSlice } from '@reduxjs/toolkit'
import { revertAll } from './../store';

const initialState = {
  value: null
};

export const barometerContextSlice = createSlice({
  name: 'barometerContext',
  initialState,
  reducers: {
    updateBarometerContext: ( state, action ) => 
		{
      state.value = action.payload;
    }
  },
  extraReducers: builder => builder.addCase( revertAll, () => initialState )
})

export const { updateBarometerContext } = barometerContextSlice.actions

export default barometerContextSlice.reducer